// ─── En-tête de page (Core) ───────────────────────────────────────
// Gabarit standard de la suite (levé de MoPCal, sans la dépendance à l'aide).
// Usage : <PageHeader titre="…" onRetour={…} action={{icone,onPress}}>…</PageHeader>
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useUI } from '../theme/PreferencesUI';

const HIT = { top: 8, bottom: 8, left: 8, right: 8 };

export default function PageHeader({ titre, iconeTitre, onRetour, action, children, paddingTop }) {
  const UI = useUI();
  const insets = useSafeAreaInsets();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={[s.header, { paddingTop: paddingTop != null ? paddingTop : insets.top + 10 }]}>
      {onRetour ? (
        <TouchableOpacity onPress={onRetour} hitSlop={HIT} accessibilityLabel="Retour">
          <Text style={s.chevron}>‹</Text>
        </TouchableOpacity>
      ) : null}
      {!!iconeTitre && <Text style={s.iconeTitre}>{iconeTitre}</Text>}
      <Text style={s.titre} numberOfLines={1}>{titre}</Text>
      {action ? (
        <TouchableOpacity
          onPress={action.enErreur ? action.onErreur : action.onPress}
          disabled={action.enErreur ? !action.onErreur : action.disabled}
          hitSlop={HIT} accessibilityLabel={action.label}>
          {/* Désactivé : opacité (et non couleur — une EMOJI ignore `color`).
              3 états (principe app-wide) : grisée = rien à enregistrer ;
              grisée + pastille « ! » = modifié mais une INCOHÉRENCE bloque
              (le tap appelle onErreur → montrer les champs en rouge) ;
              pleine = enregistrable. */}
          <View>
            <Text style={[s.action, (action.disabled || action.enErreur) && { opacity: 0.3 }]}>{action.icone}</Text>
            {!!action.enErreur && (
              <View style={s.badgeErr}><Text style={s.badgeErrTxt}>!</Text></View>
            )}
          </View>
        </TouchableOpacity>
      ) : null}
      {/* Grappe d'actions propre à l'écran, rendue APRÈS l'action principale
          (convention MoPCal : 💾 puis ✕ / bascules). */}
      {children}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  header: {
    flexDirection: 'row', alignItems: 'center', gap: 10,
    paddingHorizontal: 14, paddingBottom: 10,
    backgroundColor: UI.card, borderBottomWidth: 0.5, borderBottomColor: UI.border,
  },
  chevron:    { fontSize: 26, lineHeight: 28, color: UI.accent, fontWeight: '300' },
  iconeTitre: { fontSize: 18 },
  titre:      { flex: 1, fontSize: 17, fontWeight: '800', color: UI.ink },
  action:     { fontSize: 22, color: UI.accent },
  badgeErr:   { position: 'absolute', top: -4, right: -7, minWidth: 14, height: 14, borderRadius: 7,
                backgroundColor: UI.danger, alignItems: 'center', justifyContent: 'center', paddingHorizontal: 2 },
  badgeErrTxt:{ color: '#fff', fontSize: 10, fontWeight: '800', lineHeight: 13 },
});
